import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section, StatusBadge } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function Loans() {
  const [loans, setLoans] = useState([]);
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ user_id: "", loan_type: "Advance", principal: 0, monthly_deduction: 0, start_month: new Date().toISOString().slice(0, 7), reason: "" });

  const load = async () => {
    const [l, u] = await Promise.all([api.get("/loans"), api.get("/users/employees")]);
    setLoans(l.data); setUsers(u.data);
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/loans", form); toast.success("Loan created"); setOpen(false); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const close_ = async (id) => { await api.patch(`/loans/${id}`, { status: "closed" }); load(); };

  return (
    <div data-testid="admin-loans">
      <PageHeader overline="Compensation" title="Loans & Advances"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button className="rounded-none bg-[#FF5500] hover:bg-[#E64D00] text-white" data-testid="new-loan">+ New Loan / Advance</Button>
            </DialogTrigger>
            <DialogContent className="rounded-none">
              <DialogHeader><DialogTitle className="font-head">Create Loan or Advance</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <select value={form.user_id} onChange={(e) => setForm({ ...form, user_id: e.target.value })} className="w-full h-10 border border-[#E5E5E5] px-2 bg-white" data-testid="loan-user">
                  <option value="">Select employee…</option>
                  {users.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
                </select>
                <select value={form.loan_type} onChange={(e) => setForm({ ...form, loan_type: e.target.value })} className="w-full h-10 border border-[#E5E5E5] px-2 bg-white">
                  <option>Advance</option><option>Loan</option>
                </select>
                <div className="grid grid-cols-2 gap-3">
                  <Input type="number" placeholder="Principal (₹)" value={form.principal} onChange={(e) => setForm({ ...form, principal: parseFloat(e.target.value) || 0 })} className="rounded-none" data-testid="loan-principal" />
                  <Input type="number" placeholder="Monthly deduction (₹)" value={form.monthly_deduction} onChange={(e) => setForm({ ...form, monthly_deduction: parseFloat(e.target.value) || 0 })} className="rounded-none" data-testid="loan-monthly" />
                </div>
                <Input type="month" value={form.start_month} onChange={(e) => setForm({ ...form, start_month: e.target.value })} className="rounded-none" />
                <Input placeholder="Reason / notes" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} className="rounded-none" />
                <Button onClick={save} className="w-full rounded-none bg-[#FF5500]" data-testid="save-loan">Create</Button>
              </div>
            </DialogContent>
          </Dialog>
        } />
      <Section title={`${loans.length} entries`}>
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Employee</th><th className="eyebrow">Type</th>
              <th className="eyebrow">Principal</th><th className="eyebrow">Monthly</th>
              <th className="eyebrow">Remaining</th><th className="eyebrow">Start</th>
              <th className="eyebrow">Status</th><th />
            </tr>
          </thead>
          <tbody>
            {loans.length === 0 && <tr><td colSpan={8} className="text-center py-6 text-neutral-500">No loans or advances</td></tr>}
            {loans.map((l) => {
              const user = users.find(u => u.id === l.user_id);
              return (
                <tr key={l.id} className="border-b border-[#F0F0EE]">
                  <td className="font-medium">{user?.name || l.user_id}</td>
                  <td>{l.loan_type}</td>
                  <td>₹{l.principal?.toLocaleString()}</td>
                  <td>₹{l.monthly_deduction?.toLocaleString()}</td>
                  <td className="font-semibold">₹{l.remaining?.toLocaleString()}</td>
                  <td>{l.start_month}</td>
                  <td><StatusBadge status={l.status} /></td>
                  <td>{l.status === "active" && <button onClick={() => close_(l.id)} className="text-xs underline hover:text-[#1F4E8C]">Close</button>}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Section>
    </div>
  );
}
